// CacheKey 21f73dcc544a87e63ca26fa6c460f115
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ACCOUNT_STRATEGY": {
    filters: {
      arrival: {
        label: "Product Launch",
        title: "Filter by product launch date"
      },
      captain: {
        label: "Advisor",
        title: "Filter by advisor name"
      },
      captain_name: {
        label: "Advisor",
        title: "Filter by advisor name"
      },
      discharge: {
        label: "Product End Date",
        title: "Filter by product end date"
      },
      encounter: {
        label: "Product",
        title: "Filter by product id"
      },
      encounter_updated_at: {
        label: "Product Updated At",
        title: "Filter by product updated at"
      },
      facility: {
        label: "Building",
        title: "Filter by building"
      },
      gender: {
        label: "Account Type",
        title: "filter by account type"
      },
      plan: {
        label: "Workflow",
        title: "Filter by workflow"
      },
      patient: {
        label: "Account",
        title: "Filter by account"
      },
      patient_tags: {
        label: "Account tags",
        title: "Filter by account tags"
      },
      tags: {
        label: "tags",
        title: "Filter by tag"
      }
    }
  }
}

